import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useEffect, useRef } from 'react';
import { useMappingService, useTrackingService } from './serviceHooks';

export const useProductViewTracker = (
    relewiseProductId: string | undefined,
    primarySizeVariantRelewiseId: string | undefined,
    request: IRequestContext,
    telemetry: ITelemetry
) => {
    const lastTrackedVariantRef = useRef<string | undefined>();
    const relewiseTrackingService = useTrackingService(request, telemetry);
    const relewiseMappingService = useMappingService(request, telemetry);

    useEffect(() => {
        if (typeof window === 'undefined' || !relewiseProductId || !primarySizeVariantRelewiseId) {
            return;
        }

        if (primarySizeVariantRelewiseId !== lastTrackedVariantRef.current) {
            relewiseTrackingService.trackProductView(relewiseProductId, primarySizeVariantRelewiseId);
            lastTrackedVariantRef.current = primarySizeVariantRelewiseId;
        }
    }, [relewiseProductId, primarySizeVariantRelewiseId, relewiseTrackingService, relewiseMappingService]);
};
